import React from 'react';
import { FileText, AlertCircle, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Helmet } from 'react-helmet-async';

const CustomsDutiesGuidePage = () => {
  return (
    <>
      <Helmet>
        <title>India Customs Duties Guide | Shipping from Canada – Shippzy</title>
        <meta name="description" content="Complete guide to Indian customs duties for shipments from Canada. Understand duty rates, exemptions, documentation requirements, and clearance procedures." />
        <link rel="canonical" href="https://www.shippzy.ca/customs-duties-guide-india" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Indian Customs Duties Guide</h1>
              <p className="text-xl text-gray-300 mb-8">Understanding customs duties and documentation when shipping from Canada to India.</p>
            </div>
          </div>
        </section>
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8 p-6 bg-yellow-50 border-l-4 border-yellow-500 rounded">
              <div className="flex gap-3"><AlertCircle className="w-6 h-6 text-yellow-600 flex-shrink-0" /><div><h3 className="font-semibold text-gray-900 mb-2">Important Notice</h3><p className="text-gray-700">Customs duties are determined by Indian customs authorities based on declared value, item type, and current regulations. Shippzy provides documentation support but cannot guarantee duty amounts.</p></div></div>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Common Duty Categories</h2>
            <div className="space-y-6">
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Personal Belongings</h3><p className="text-gray-600">Used personal items typically have lower or nil duty. New items may incur standard import duties.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Gifts</h3><p className="text-gray-600">Gift shipments may qualify for duty exemptions under certain value thresholds. Proper documentation required.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Commercial Goods</h3><p className="text-gray-600">Commercial shipments are subject to applicable import duties and GST. Requires commercial invoice.</p></CardContent></Card>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CustomsDutiesGuidePage;